'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DateUtils = require('./utils/DateUtils.js');

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _DateLanguages = require('./utils/DateLanguages.js');

var _DateLanguages2 = _interopRequireDefault(_DateLanguages);

var _UiButton = require('../material/UiButton.vue');

var _UiButton2 = _interopRequireDefault(_UiButton);

var _UiIconButton = require('../material/UiIconButton.vue');

var _UiIconButton2 = _interopRequireDefault(_UiIconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    value: {
      validator: function validator(val) {
        return val === null || val instanceof Date;
      }
    },
    label: {
      value: String
    },
    name: {
      value: String,
      default: 'date-picker'
    },
    format: {
      value: String,
      default: 'dd MMM yyyy'
    },
    language: {
      value: String,
      default: 'es'
    },
    disabled: {
      type: Object
    },
    placeholder: {
      type: String
    },
    inline: {
      type: Boolean
    },
    inputClass: {
      type: String
    },
    wrapperClass: {
      type: String
    },
    mondayFirst: {
      type: Boolean,
      default: false
    }
  },
  components: {
    UiButton: _UiButton2.default,
    UiIconButton: _UiIconButton2.default
  },
  data: function data() {
    return {
      currDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime(),
      selectedDate: null,
      selectedYear: new Date(),
      showCalendarAll: false,
      showDayView: false,
      showMonthView: false,
      showYearView: false,
      flagPrevMonth: false,
      flagNextMonth: false,
      activeYearTitle: false,
      activeMonthDayTitle: false,
      translation: _DateLanguages2.default.translations[this.language],
      calendarHeight: 0
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    }
  },
  computed: {
    formattedValue: function formattedValue() {
      if (!this.value) {
        return null;
      }
      return _DateUtils2.default.formatDate(new Date(this.value), this.format, this.translation);
    },
    currDayName: function currDayName() {
      var d = new Date(this.selectedDate);
      return _DateUtils2.default.getDayName(d.getDay(), this.translation.days);
    },
    currMonthName: function currMonthName() {
      var d = new Date(this.currDate);
      return _DateUtils2.default.getMonthNameAbbr(d.getMonth(), this.translation.months.abbr);
    },
    currYear: function currYear() {
      var d = new Date(this.currDate);
      return d.getFullYear();
    },
    currYearNumber: function currYearNumber() {
      var d = '';
      if (this.value) {
        d = new Date(this.value);
      } else {
        d = new Date(this.selectedYear);
      }
      return d.getFullYear();
    },
    currMonthNumber: function currMonthNumber() {
      var d = new Date(this.selectedDate);
      var _month = d.getMonth() + 1;
      var _temp = _month < 10 ? '0' + _month : _month;
      return _temp;
    },
    currDayNumber: function currDayNumber() {
      var d = _DateUtils2.default.formatDate(new Date(this.selectedDate), this.format, this.translation).split('/');
      return d[2];
    },

    /**
     * Returns the day number of the week less one for the first of the current month
     * Used to show amount of empty cells before the first in the day calendar layout
     * @return {Number}
     */
    blankDays: function blankDays() {
      var d = new Date(this.currDate);
      var dObj = new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      if (this.mondayFirst) {
        return dObj.getDay() > 0 ? dObj.getDay() - 1 : 6;
      }
      return dObj.getDay();
    },
    daysOfWeek: function daysOfWeek() {
      if (this.mondayFirst) {
        var tempDays = this.translation.days.slice();
        tempDays.push(tempDays.shift());
        return tempDays;
      }
      return this.translation.days;
    },
    days: function days() {
      var d = new Date(this.currDate);
      var days = [];
      // set up a new date object to the beginning of the current 'page'
      var dObj = new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      var daysInMonth = _DateUtils2.default.daysInMonth(dObj.getFullYear(), dObj.getMonth());
      for (var i = 0; i < daysInMonth; i++) {
        days.push({
          date: dObj.getDate(),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedDate(dObj),
          isDisabled: this.isDisabledDate(dObj)
        });
        dObj.setDate(dObj.getDate() + 1);
      }
      return days;
    },
    months: function months() {
      var d = new Date(this.currDate);
      var months = [];
      // set up a new date object to the beginning of the current 'page'
      var dObj = new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());
      for (var i = 0; i < 12; i++) {
        months.push({
          month: _DateUtils2.default.getMonthName(i, this.translation.months.original),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedMonth(dObj),
          isDisabled: this.isDisabledMonth(dObj)
        });
        dObj.setMonth(dObj.getMonth() + 1);
      }
      return months;
    },
    years: function years() {
      var d = new Date(this.currDate);
      var years = [];
      // set up a new date object to the beginning of the current 'page'
      var dObj = new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());
      for (var i = 0; i < 10; i++) {
        years.push({
          year: dObj.getFullYear(),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedYear(dObj),
          isDisabled: this.isDisabledYear(dObj)
        });
        dObj.setFullYear(dObj.getFullYear() + 1);
      }
      return years;
    }
  },
  methods: {
    close: function close() {
      this.showDayView = this.showMonthView = this.showYearView = this.showCalendarAll = false;
    },
    isOpen: function isOpen() {
      return this.showDayView || this.showMonthView || this.showYearView;
    },
    showCalendar: function showCalendar() {
      if (this.isOpen()) {
        return this.close();
      }
      this.activeMonthDayTitle = true;
      this.activeYearTitle = false;
      this.selectedDate = this.value;
      this.showDayCalendar();
    },
    showDayCalendar: function showDayCalendar() {
      this.close();
      this.activeMonthDayTitle = true;
      this.activeYearTitle = false;
      this.showDayView = true;
      this.showCalendarAll = true;
    },
    showMonthCalendar: function showMonthCalendar() {
      this.close();
      this.showCalendarAll = true;
      this.showMonthView = true;
    },
    showYearCalendar: function showYearCalendar() {
      this.close();
      this.activeMonthDayTitle = false;
      this.activeYearTitle = true;
      this.showCalendarAll = true;
      this.showYearView = true;
    },
    setDate: function setDate(timestamp) {
      this.selectedDate = new Date(timestamp);
      this.currDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1).getTime();
    },
    onSubmitDate: function onSubmitDate() {
      this.$emit('input', this.selectedDate);
      this.$emit('selected', this.selectedDate);
      this.close();
    },
    selectDate: function selectDate(day) {
      if (day.isDisabled) {
        return false;
      }
      this.setDate(day.timestamp);
      /*
        if (this.isInline()) {
          return this.showDayCalendar()
        }
       * this.close()
       */
    },
    selectMonth: function selectMonth(month) {
      if (month.isDisabled) {
        return false;
      }
      this.currDate = month.timestamp;
      this.showDayCalendar();
    },
    selectYear: function selectYear(year) {
      if (year.isDisabled) {
        return false;
      }
      this.currDate = year.timestamp;
      this.selectedYear = year.timestamp;
      this.showDayCalendar();
      /**
       * this.showMonthCalendar()this.showDayCalendar()
       */
    },
    getMonth: function getMonth() {
      var d = new Date(this.currDate);
      return d.getMonth();
    },
    getYear: function getYear() {
      var d = new Date(this.currDate);
      return d.getFullYear();
    },
    getDecade: function getDecade() {
      var d = new Date(this.currDate);
      var sD = Math.floor(d.getFullYear() / 10) * 10;
      return sD + '\'s';
    },
    previousMonth: function previousMonth() {
      if (this.previousMonthDisabled()) {
        return false;
      }
      var d = new Date(this.currDate);
      d.setMonth(d.getMonth() - 1);
      this.currDate = d.getTime();
    },
    previousMonthDisabled: function previousMonthDisabled() {
      if (typeof this.disabled === 'undefined' || typeof this.disabled.to === 'undefined' || !this.disabled.to) {
        return false;
      }
      var d = new Date(this.currDate);
      if (this.disabled.to.getMonth() >= d.getMonth() && this.disabled.to.getFullYear() >= d.getFullYear()) {
        return true;
      }
      return false;
    },
    nextMonth: function nextMonth() {
      if (this.nextMonthDisabled()) {
        return false;
      }
      var d = new Date(this.currDate);
      var daysInMonth = _DateUtils2.default.daysInMonth(d.getFullYear(), d.getMonth());
      d.setDate(d.getDate() + daysInMonth);
      this.currDate = d.getTime();
    },
    nextMonthDisabled: function nextMonthDisabled() {
      if (typeof this.disabled === 'undefined' || typeof this.disabled.from === 'undefined' || !this.disabled.from) {
        return false;
      }
      var d = new Date(this.currDate);
      if (this.disabled.from.getMonth() <= d.getMonth() && this.disabled.from.getFullYear() <= d.getFullYear()) {
        return true;
      }
      return false;
    },
    previousYear: function previousYear() {
      if (this.previousYearDisabled()) {
        return false;
      }
      var d = new Date(this.currDate);
      d.setYear(d.getFullYear() - 1);
      this.currDate = d.getTime();
    },
    previousYearDisabled: function previousYearDisabled() {
      if (typeof this.disabled === 'undefined' || typeof this.disabled.to === 'undefined' || !this.disabled.to) {
        return false;
      }
      var d = new Date(this.currDate);
      if (this.disabled.to.getFullYear() >= d.getFullYear()) {
        return true;
      }
      return false;
    },
    nextYear: function nextYear() {
      if (this.nextYearDisabled()) {
        return false;
      }
      var d = new Date(this.currDate);
      d.setYear(d.getFullYear() + 1);
      this.currDate = d.getTime();
    },
    nextYearDisabled: function nextYearDisabled() {
      if (typeof this.disabled === 'undefined' || typeof this.disabled.from === 'undefined' || !this.disabled.from) {
        return false;
      }
      var d = new Date(this.currDate);
      if (this.disabled.from.getFullYear() <= d.getFullYear()) {
        return true;
      }
      return false;
    },
    previousDecade: function previousDecade() {
      if (this.previousDecadeDisabled()) {
        return false;
      }
      var d = new Date(this.currDate);
      d.setYear(d.getFullYear() - 10);
      this.currDate = d.getTime();
    },
    previousDecadeDisabled: function previousDecadeDisabled() {
      if (typeof this.disabled === 'undefined' || typeof this.disabled.to === 'undefined' || !this.disabled.to) {
        return false;
      }
      var d = new Date(this.currDate);
      if (Math.floor(this.disabled.to.getFullYear() / 10) * 10 >= Math.floor(d.getFullYear() / 10) * 10) {
        return true;
      }
      return false;
    },
    nextDecade: function nextDecade() {
      if (this.nextDecadeDisabled()) {
        return false;
      }
      var d = new Date(this.currDate);
      d.setYear(d.getFullYear() + 10);
      this.currDate = d.getTime();
    },
    nextDecadeDisabled: function nextDecadeDisabled() {
      if (typeof this.disabled === 'undefined' || typeof this.disabled.from === 'undefined' || !this.disabled.from) {
        return false;
      }
      var d = new Date(this.currDate);
      if (Math.ceil(this.disabled.from.getFullYear() / 10) * 10 <= Math.ceil(d.getFullYear() / 10) * 10) {
        return true;
      }
      return false;
    },
    isSelectedDate: function isSelectedDate(dObj) {
      return this.selectedDate && this.selectedDate.toDateString() === dObj.toDateString();
    },
    isDisabledDate: function isDisabledDate(date) {
      var disabled = false;

      if (typeof this.disabled === 'undefined') {
        return false;
      }

      if (typeof this.disabled.dates !== 'undefined') {
        this.disabled.dates.forEach(function (d) {
          if (date.toDateString() === d.toDateString()) {
            disabled = true;
            return true;
          }
        });
      }
      if (typeof this.disabled.to !== 'undefined' && this.disabled.to && date < this.disabled.to) {
        disabled = true;
      }
      if (typeof this.disabled.from !== 'undefined' && this.disabled.from && date > this.disabled.from) {
        disabled = true;
      }
      if (typeof this.disabled.days !== 'undefined' && this.disabled.days.indexOf(date.getDay()) !== -1) {
        disabled = true;
      }
      return disabled;
    },
    isSelectedMonth: function isSelectedMonth(date) {
      return this.selectedDate && this.selectedDate.getFullYear() === date.getFullYear() && this.selectedDate.getMonth() === date.getMonth();
    },
    isDisabledMonth: function isDisabledMonth(date) {
      var disabled = false;

      if (typeof this.disabled === 'undefined') {
        return false;
      }

      if (typeof this.disabled.to !== 'undefined' && this.disabled.to) {
        if (date.getMonth() < this.disabled.to.getMonth() && date.getFullYear() <= this.disabled.to.getFullYear() || date.getFullYear() < this.disabled.to.getFullYear()) {
          disabled = true;
        }
      }
      if (typeof this.disabled.from !== 'undefined' && this.disabled.from) {
        if (this.disabled.from && date.getMonth() > this.disabled.from.getMonth() && date.getFullYear() >= this.disabled.from.getFullYear() || date.getFullYear() > this.disabled.from.getFullYear()) {
          disabled = true;
        }
      }
      return disabled;
    },
    isSelectedYear: function isSelectedYear(date) {
      return this.selectedDate && this.selectedDate.getFullYear() === date.getFullYear();
    },
    isDisabledYear: function isDisabledYear(date) {
      var disabled = false;
      if (typeof this.disabled === 'undefined' || !this.disabled) {
        return false;
      }

      if (typeof this.disabled.to !== 'undefined' && this.disabled.to) {
        if (date.getFullYear() < this.disabled.to.getFullYear()) {
          disabled = true;
        }
      }
      if (typeof this.disabled.from !== 'undefined' && this.disabled.from) {
        if (date.getFullYear() > this.disabled.from.getFullYear()) {
          disabled = true;
        }
      }

      return disabled;
    },
    setValue: function setValue(date) {
      if (!date) {
        var d = new Date();
        this.currDate = new Date(d.getFullYear(), d.getMonth(), 1).getTime();
        this.selectedDate = null;
        return;
      }
      this.selectedDate = date;
      this.currDate = new Date(date.getFullYear(), date.getMonth(), 1).getTime();
    },
    init: function init() {
      if (this.value) {
        this.setValue(this.value);
      }
    }
  },
  /**
   * Vue 1.x
   */
  ready: function ready() {
    this.init();
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"ui-textbox\">\n    <div class=\"ui-textbox-content\">\n      <div class=\"ui-textbox-label\">\n        <div class=\"ui-textbox-label-text\">{{label}}</div>\n        <div class=\"datepicker\" :class=\"wrapperClass\">\n          <input type=\"text\" :class=\"inputClass\" :name=\"name\" @click=\"showCalendar()\" :value=\"formattedValue\" :placeholder=\"placeholder\">\n        </div>\n      </div>\n    </div>\n  </div>\n<div class=\"modal-mask\" v-if=\"showCalendarAll\">\n  <div class=\"calendar-content clearfix\">\n    <div class=\"mu-date-display\">\n      <div class=\"mu-date-display-year\" :class=\"{'active':activeYearTitle}\">\n        <div class=\"mu-date-display-slideIn-wrapper\">\n          <div class=\"mu-date-display-year-title\" @click=\"showYearCalendar()\">{{currYearNumber}}</div>\n        </div>\n      </div>\n    </div>\n    <!-- Day View -->\n    <div class=\"calendar calendar-day clearfix\" v-if=\"showDayView\">\n      <header class=\"header-days\">\n        <div class=\"clearfix\">\n          <ui-icon-button @click=\"previousMonth\" type=\"flat\" icon=\"keyboard_arrow_left\" :disabled=\"previousMonthDisabled(currDate)\" color=\"btn-left\"></ui-icon-button>\n          <span class=\"up\">{{ currMonthName }} {{currYear}}</span>\n          <ui-icon-button @click=\"nextMonth\" type=\"flat\" icon=\"keyboard_arrow_right\" :disabled=\"nextMonthDisabled(currDate)\" color=\"btn-right\"></ui-icon-button>\n        </div>\n      </header>\n      <span class=\"cell day-header\" v-for=\"d in daysOfWeek\">{{ d }}</span>\n      <span class=\"cell day blank\" v-for=\"d in blankDays\"></span>\n      <span class=\"cell day\" v-for=\"day in days\" track-by=\"timestamp\" :class=\"{ 'selected':day.isSelected, 'disabled':day.isDisabled }\" @click=\"selectDate(day)\"><span class=\"circle\">{{ day.date }}</span></span>\n    </div>\n    <!-- Month View -->\n    <div class=\"calendar calendar-month clearfix\" v-if=\"showMonthView\">\n      <header class=\"header-month\">\n        <span @click=\"previousYear\" class=\"prev\" v-bind:class=\"{ 'disabled' : previousYearDisabled(currDate) }\">&lt;</span>\n        <span @click=\"showYearCalendar\" class=\"up\">{{ getYear() }}</span>\n        <span @click=\"nextYear\" class=\"next\" v-bind:class=\"{ 'disabled' : nextYearDisabled(currDate) }\">&gt;</span>\n      </header>\n      <span class=\"cell month\" v-for=\"month in months\" track-by=\"timestamp\" v-bind:class=\"{ 'selected': month.isSelected, 'disabled': month.isDisabled }\" @click.stop=\"selectMonth(month)\">{{ month.month }}</span>\n    </div>\n    <!-- Year View -->\n    <div class=\"calendar calendar-year clearfix\" v-if=\"showYearView\">\n      <header class=\"header-year\">\n        <div class=\"clearfix\">\n          <ui-icon-button @click=\"previousDecade\" type=\"flat\" icon=\"keyboard_arrow_left\" :disabled=\"previousDecadeDisabled(currDate)\" color=\"btn-left\"></ui-icon-button>\n          <span class=\"up\">{{ getDecade() }}</span>\n          <ui-icon-button @click=\"nextDecade\" type=\"flat\" icon=\"keyboard_arrow_right\" :disabled=\"nextMonthDisabled(currDate)\" color=\"btn-right\"></ui-icon-button>\n          </div>\n      </header>\n      <span class=\"cell year\" v-for=\"year in years\" track-by=\"timestamp\" :class=\"{ 'selected': year.isSelected, 'disabled': year.isDisabled }\" @click.stop=\"selectYear(year)\">{{ year.year }}</span>\n    </div>\n\n    <div class=\"clearfix text-right btn-aceptar\">\n      <ui-button @click=\"close()\" :text=\"(language=='es')?'Cancelar':'Cancel'\" color=\"anda-primario-text\"></ui-button>\n      <ui-button @click=\"onSubmitDate()\" :text=\"(language=='es')?'Aceptar':'Accept'\" color=\"anda-secundario-text\"></ui-button>\n    </div>\n  </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-005de7ce", module.exports)
  } else {
    hotAPI.update("_v-005de7ce", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}